import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Keeps the PDP benefits list in sync with the selected variant.
 *
 * The benefits come from variant-level metafields (plytix.benefit_1..5), and the
 * variant picker only morphs itself on the product page, so this element pulls its
 * own markup out of the freshly fetched document carried by the variant update event.
 *
 * @extends {HTMLElement}
 */
class PdpBenefits extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBenefits);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBenefits);
  }

  /**
   * Updates the benefits list.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBenefits = (event) => {
    const { target } = event;

    // Complementary upsell cards sit in this same section; they are not this product.
    if (target instanceof HTMLElement && target.closest('product-card, quick-add-dialog')) return;
    if (event.detail.data.productId !== this.dataset.productId) return;

    const newBenefits = event.detail.data.html.querySelector('pdp-benefits');

    if (!newBenefits) return;

    morph(this, newBenefits, { childrenOnly: true });
  };
}

if (!customElements.get('pdp-benefits')) {
  customElements.define('pdp-benefits', PdpBenefits);
}
